import {
  withCompInfo,
  withCompPreviewInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  ColumnDefinition,
  ColumnCarmiData,
  ColumnCss,
} from '../Column.types';
import {
  ARIA_LABEL_DEFAULT,
  ARIA_LABEL_KEY,
  ARIA_LABEL_NAMESPACE,
} from '../constants';

export const props = withCompInfo<
  ColumnCarmiData,
  ColumnDefinition,
  ColumnCarmiData
>()(['translate'], ({ translate }, carmiData) => {
  return {
    ...carmiData,
    translations: {
      ariaLabel:
        translate(ARIA_LABEL_NAMESPACE, ARIA_LABEL_KEY) || ARIA_LABEL_DEFAULT,
    },
  };
});

export const css = withCompPreviewInfo<
  ColumnCss,
  ColumnDefinition,
  ColumnCss
>()([], (_, carmiData) => {
  return carmiData;
});

const uiType = withCompInfo<any, any>()(['skin'], ({ skin }) => {
  if (skin === 'DesignedColumn') {
    return 'DesignedColumn';
  }
  return 'DefaultColumn';
});

export default createComponentMapperModel({
  props,
  css,
  uiType,
});
